/* tq-build · accordion: one open at a time; rotates on its own until the visitor taps. */
(() => {
  document.querySelectorAll('[data-tq-acc]').forEach((acc) => {
    const items = [...acc.querySelectorAll('.tq-acc__item')];
    const MS = 6500;
    let timer, current = Math.max(0, items.findIndex((i) => i.classList.contains('is-open')));
    const open = (n) => {
      items.forEach((it, i) => {
        const on = i === n;
        it.classList.toggle('is-open', on);
        it.querySelector('.tq-acc__btn').setAttribute('aria-expanded', String(on));
        it.querySelector('.tq-acc__panel').hidden = !on;
        const bar = it.querySelector('.tq-acc__bar span');   /* restart the fill */
        bar.style.animation = 'none'; void bar.offsetHeight; bar.style.animation = '';
      });
      current = n;
    };
    const stop = () => { clearInterval(timer); acc.classList.remove('is-auto'); };
    items.forEach((it, i) => it.querySelector('.tq-acc__btn').addEventListener('click', () => { stop(); open(i); }));
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || items.length < 2) return;
    /* Only rotate while the section is on screen, so nobody misses the first item. */
    const start = () => {
      if (timer || !acc.isConnected) return;
      acc.style.setProperty('--tq-acc-ms', `${MS}ms`);
      acc.classList.add('is-auto');
      open(current);
      timer = setInterval(() => open((current + 1) % items.length), MS);
    };
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.isIntersecting && acc.dataset.stopped !== '1') start();
        else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; acc.classList.remove('is-auto'); }
      });
    }, { threshold: 0.4 });
    io.observe(acc);
    acc.addEventListener('click', () => { acc.dataset.stopped = '1'; io.disconnect(); });
  });
})();
